<template>
  <footer class="footer body-width">
    <div class="content">
      <div class="logo"><img src="@/assets/img/footer/logo.png" alt="" /></div>
      <div class="li ml160">
        <div class="title">{{ $t("components[0].footer.title[0]") }}</div>
        <div
          class="text link"
          v-for="(item, index) in CATEGORIES"
          @click="handleSelectf(item.url)"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="li">
        <div class="title">{{ $t("components[0].footer.title[1]") }}</div>
        <div
          class="text link"
          v-for="(item, index) in LINKS"
          @click="handleSelectf(item.url)"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="li">
        <div class="title">{{ $t("components[0].footer.title[2]") }}</div>
        <div
          class="contactus text"
          v-for="(item, index) in Contact"
          :key="index"
        >
          <div class="img-center">
            <img v-if="item.url" :src="item.url" alt="" class="img-typpe" />
          </div>
          <div>
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="li">
        <div class="title">{{ $t("components[0].footer.title[3]") }}</div>
        <div
          class="contactus text link"
          v-for="(item, index) in Social"
          :key="index"
          @click="gotourl(item.url)"
        >
          <div class="img-center">
            <img v-if="item.img" :src="item.img" alt="" class="img-typpe" />
          </div>
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      CATEGORIES: [
        {
          name: this.$t("components[0].footer.CATEGORIES[0]"),
          url: "freezeDried",
        },
        {
          name: this.$t("components[0].footer.CATEGORIES[1]"),
          url: "vacuumFried",
        },
        {
          name: this.$t("components[0].footer.CATEGORIES[2]"),
          url: "semiDried",
        },
        {
          name: this.$t("components[0].footer.CATEGORIES[3]"),
          url: "toastedDried",
        },
        { name: this.$t("components[0].footer.CATEGORIES[4]"), url: "airdired" },
        { name: this.$t("components[0].footer.CATEGORIES[5]"), url: "nut" },
      ], // 默认选中的菜单项
      LINKS: [
        { name: this.$t("components[0].footer.LINKS[0]"), url: "home" },
        { name: this.$t("components[0].footer.LINKS[1]"), url: "aboutous" },
        {
          name: this.$t("components[0].footer.LINKS[2]"),
          url: "qualityControl",
        },
        { name: this.$t("components[0].footer.LINKS[3]"), url: "cataLog" },
        {
          name: this.$t("components[0].footer.LINKS[4]"),
          url: "cooperationCase",
        },
        { name: this.$t("components[0].footer.LINKS[5]"), url: "control" },
        { name: this.$t("components[0].footer.LINKS[6]"), url: "blog" },
      ],
      dq: this.$t("components[0].footer.title[4]"),
      Contact: [
        { name: this.$t("components[0].footer.Contact[0]") },
        {
          name: this.$t("components[0].footer.Contact[1]"),
          url: require("@/assets/img/footer/phone.png"),
        },
        {
          name: this.$t("components[0].footer.Contact[2]"),
          url: require("@/assets/img/footer/email.png"),
        },
        {
          name: this.$t("components[0].footer.Contact[3]"),
          url: require("@/assets/img/footer/dz.png"),
        },
      ],
      Social: [
        {
          name: this.$t("components[0].footer.Social[0]"),
          url: "https://www.instagram.com/fdfurit/",
          img: require("@/assets/img/footer/instagram.png"),
        },
        {
          name: this.$t("components[0].footer.Social[1]"),
          url: "https://www.facebook.com/profile.php?id=61567074647888",
          img: require("@/assets/img/footer/facebook.png"),
        },
        {
          name: this.$t("components[0].footer.Social[2]"),
          url: "https://api.whatsapp.com/send/?phone=8613512282858&text&type=phone_number&app_absent=0",
          img: require("@/assets/img/footer/whatsapp.png"),
        },
        {
          name: this.$t("components[0].footer.Social[3]"),
          url: "https://www.linkedin.com/company/tianjin-green-crispy-foods/?viewAsMember=true",
          img: require("@/assets/img/footer/linkedin.png"),
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      let path = to.path;
      path = path.substring(1);
      this.dq = path;
      // 这里可以根据路由变化决定是否隐藏导航栏
      // this.activeIndex = to.path === "/about"; // 示例: 当访问 '/about' 时隐藏导航
    },
  },
  methods: {
    handleSelectf(url) {
      console.log();
      if (this.dq == url) return;
      this.dq = url; // 更新选中的菜单项
      // 可以在这里进行路由导航等操作
      // console.log(`选择了菜单: ${index}`);
      if (url == "") {
        return;
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
      this.$router.push({
        name: url,
      });
    },
    gotourl(item) {
      window.open(item);
    },
  },
};
</script>
<style scoped lang="scss">
.footer {
  color: #ffffff;
  background-image: url("@/assets/img/footer/footer.png");
  background-size: cover; /* 或者使用 'contain' */
  background-position: center center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 不重复背景图片 */
  padding: 100px 116px 160px;
}
.content {
  opacity: 0.8;
  position: relative;
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.li {
  flex: 1;
  margin: 0 20px;
  &.ml160 {
    margin-left: 160px;
  }
}
.logo {
  flex: 0 115px;
  // min-width: 115px;;
}
.title {
  margin-bottom: 28px;
  text-align: left;
  font-size: 24px;
  font-weight: 600;
}
.text {
  font-size: 18px;
  color: #ffffff;
  line-height: 24px;
  margin: 8px 0;
  text-align: left;
}
.link {
  cursor: pointer;
}
.contactus {
  display: flex;
  margin-top: 20px;
}
.img-center {
  display: flex;
  align-items: center;
  height: 24px;
}
.img-typpe {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
</style>
